import template from './episodevalue.html';
import controller from './episodevalue.controller';
import './episodevalue.styl';

let episodevalueComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default episodevalueComponent;



// WEBPACK FOOTER //
// ./client/app/common/admin/episodevalue/episodevalue.component.js